module.exports = __webpack_public_path__ + "media/images/landing__bg--phone-c577532b54e3b859262f7e2af1e2e5be.jpg";